
import { BlogSection } from '@/types/blog';

export const intro: BlogSection = {
  id: 'intro',
  title: 'Manche Menschen lehren aus Weisheit, andere nur aus Lautstärke',
  content: `
<p class="text-lg font-medium mb-6">
  Es gibt viele Stimmen da draußen. Coaches, Gurus, Finanzexperten, spirituelle Lehrer... Manche leiten, manche lenken ab, und manche nutzen die Suche anderer aus. Wie unterscheidet man, wer wirklich weiß – und wer nur redet? 🤔
</p>

<p class="mb-4">
  In unserer Zeit der Informationsüberflutung und der sozialen Medien ist es leichter denn je, sich als Experte zu präsentieren. Ein Instagram-Account, eine professionell aussehende Website, einige markante Aussagen – und schon scheint jemand eine Autorität zu sein.
</p>

<p class="mb-4">
  Doch echte Expertise, wahre Weisheit und die Fähigkeit, andere Menschen auf ihrem Weg zu begleiten, erfordert mehr als nur Selbstmarketing. Es erfordert Tiefe, Erfahrung und vor allem eine ehrliche Selbsterkenntnis.
</p>

<p class="mb-4">
  Als Finanzcoach begegne ich täglich Menschen, die zuvor falschen Versprechungen gefolgt sind oder durch Informationsüberflutung verunsichert wurden. Daher möchte ich eine alte Weisheit teilen, die uns helfen kann, klarer zu sehen.
</p>

<div class="bg-primary/10 p-6 rounded-xl border-l-4 border-primary mb-8 mt-6">
  <p class="text-lg font-medium italic">
    "Der Weise weiß, dass er nichts weiß, und gerade darin liegt seine Weisheit."
  </p>
  <p class="text-right text-sm mt-2">— Sokrates (zugeschrieben)</p>
</div>

<p class="text-lg font-medium mt-8">
  Lassen Sie uns gemeinsam betrachten, welche verschiedenen Arten von "Wissenden" uns im Leben begegnen können – und wie wir die richtigen Begleiter für unseren Weg erkennen.
</p>
  `,
};
